var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddTagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 24,
    viewBox: "0 0 51 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5703 11.6094H25.9297V7.39062C25.9297 7.17488 25.7373 7 25.5 7C25.2627 7 25.0703 7.17488 25.0703 7.39062V11.6094H20.4297C20.1924 11.6094 20 11.7843 20 12C20 12.2157 20.1924 12.3906 20.4297 12.3906H25.0703V16.6094C25.0703 16.8251 25.2627 17 25.5 17C25.7373 17 25.9297 16.8251 25.9297 16.6094V12.3906H30.5703C30.8076 12.3906 31 12.2157 31 12C31 11.7843 30.8076 11.6094 30.5703 11.6094Z",
    fill: "#979EA8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 23,
    rx: 9.5,
    stroke: "#979EA8",
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTagIcon);
export default __webpack_public_path__ + "static/media/addTagIcon.9bc8e5bbd51913a0b7b0a7b971231bed.svg";
export { ForwardRef as ReactComponent };